<template>
    <div class="carousel">
        <slot
            :beforeEnter="beforeEnter"
            :afterLeave="afterLeave"
            :handleNav="handleNav"
            :handlePag="handlePag"
            :currId="currId"
            :index="index"
            :transitionName="transitionName"
            :slides="slides"
        ></slot>
    </div>
</template>

<script>

export default {
    name: "VCarousel",

    data() {
        return {
            index: 0,
            currId: null,
            transitionName: "next",
            transitionDone: true
        };
    },
    
    provide: function(){
        return {
            transitionFalse: this.beforeEnter,
            transitionTrue: this.afterLeave,
        }
    },
    
    props: {
        slides: {
            type: Array,
            required: true
        },
        autoplay: {
            type: Boolean,
            default: false
        }
    },

    beforeMount: function() {
        this.currId = this.slides[0].id;
    },

    mounted: function(){
        
        if(this.autoplay){
            setInterval(()=>{
                this.handleNav({
                    direction: 'next'
                })
            }, 6000);
        }
        
    },

    methods: {
        beforeEnter: function() {
            this.transitionDone = false;
        },
        afterLeave: function() {
            this.transitionDone = true;
        },

        handleSwipe: function() {},

        handleNav: function(payload) {

            const listLength = this.slides.length - 1;
            const { direction } = payload;

            if (!this.transitionDone) return;


            switch (direction) {
                
                case "prev":
                    if (this.index === 0) this.index = listLength;
                    else this.index = this.index - 1;
                    break;

                case "next":
                    if (this.index === listLength) this.index = 0;
                    else this.index = this.index + 1;
                    break;

                default:
                    throw new Error("carousel direction is undefined");

            }

            this.transitionName = direction;
            this.currId = this.slides[this.index].id;
        },

        handlePag: function(payload) {
            const { pagIndex } = payload;

            if (pagIndex > this.index) this.transitionName = "prev";
            else if (pagIndex < this.index) this.transitionName = "next";
            else return;

            this.index = pagIndex;
            this.currId = this.slides[this.index].id;
        }
    }
};
</script>

<style lang="scss">
</style>